// @flow
export {
  default,
} from 'web-ssr/app/app-directory/components/AppDirectoryLayout/AppDirectoryLayout';
